/* eslint-disable no-plusplus */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
export default function colorswapAction(showCursorCoords, isMouseDown, toolState, ctxMain, canvasMain, canvasToCursor, ctxToCursor, ctxPreview, drawLine, copyCanvas, canvasCur, returnCurrentFrame) {
  let prevX;
  let prevY;
  let colorToPaint;

  canvasToCursor.addEventListener('contextmenu', (e) => {
    e.preventDefault();
  });

  canvasToCursor.addEventListener('mousedown', (e) => {
    if (toolState.currentToolId === 'colorswap') {
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      isMouseDown = true;
      ctxMain.beginPath();
      if (e.button === 2) colorToPaint = toolState.secondaryColor;
      else colorToPaint = toolState.primaryColor;
      ctxMain.fillStyle = colorToPaint;

      const oneRgbaData = ctxMain.getImageData(e.offsetX, e.offsetY, 1, 1).data;
      const oneRgbaDataArr = Array.from(new Uint8ClampedArray(oneRgbaData));
      const allRgbaData = ctxMain.getImageData(0, 0, canvasMain.width, canvasMain.height).data;
      const allRgbaDataArr = Array.from(new Uint8ClampedArray(allRgbaData)).flat();

      for (let i = 0; i < allRgbaDataArr.length; i += 1) {
        if (allRgbaDataArr[i] === oneRgbaDataArr[0]) {
          if (allRgbaDataArr[i + 1] === oneRgbaDataArr[1]) {
            if (allRgbaDataArr[i + 2] === oneRgbaDataArr[2]) {
              if (allRgbaDataArr[i + 3] === oneRgbaDataArr[3]) {
                const y = Math.floor(i / canvasMain.width / 4);
                const x = (Math.floor(i / 4) - canvasMain.width * y);
                ctxMain.fillRect(x, y, 1, 1);
              }
            }
          }
        }
      }
    }
  });

  canvasToCursor.addEventListener('mouseup', () => {
    if (toolState.currentToolId === 'colorswap') {
      isMouseDown = false;
      ctxMain.beginPath();
      copyCanvas(canvasMain, canvasCur(returnCurrentFrame()));
    }
  });

  canvasToCursor.addEventListener('mouseout', () => {
    if (toolState.currentToolId === 'colorswap') {
      ctxToCursor.beginPath();
      ctxToCursor.clearRect(prevX, prevY, 1, 1);
      ctxToCursor.fill();
      showCursorCoords();
    }
  });

  canvasToCursor.addEventListener('mousemove', (e) => {
    if (toolState.currentToolId === 'colorswap') {
      showCursorCoords(e.offsetX, e.offsetY);
      if (isMouseDown === false) {
        ctxToCursor.beginPath();
        ctxToCursor.clearRect(prevX, prevY, 1, 1);
        ctxToCursor.fill();
        prevX = e.offsetX;
        prevY = e.offsetY;
        ctxToCursor.fillStyle = 'rgba(255,255,255, 0.5)';
        ctxToCursor.fillRect(e.offsetX, e.offsetY, 1, 1);
      }
    }
  });
}
